import { Component, OnInit } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { UtilityServiceService } from 'projects/services/src/app/API/utility-service.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { RegistrationService } from 'projects/services/src/app/API/registration.service';
import * as helpers from 'src/assets/vendors/base/vendors.bundle';
import { UserService } from 'projects/services/src/app/API/user.service';
declare var toastr;
declare var swal: any;
@Component({
  selector: 'app-tp-scheme-bank-details',
  templateUrl: './tp-scheme-bank-details.component.html',
  styleUrls: ['./tp-scheme-bank-details.component.css']
})
export class TpSchemeBankDetailsComponent implements OnInit {
  tpSchemeBankDetails: FormGroup
  schemeId: any;
  bankDetailsData: any;
  statusColor = {
    'Active': '#0abb87',
    'Inactive': '#fd397a',
  };
  verifyOTPForm: FormGroup;
  emailPattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$';
  currentUserDetails: any = {};
  projectType;

  constructor(private utlityService: UtilityServiceService, private formBuilder: FormBuilder,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private currentUserService: CurrentUserService,
    private registrationService: RegistrationService,
    private userService: UserService
  ) {
    this.activatedRoute.queryParams
      .subscribe(params => {
        console.log(params);
        this.activatedRoute.params.subscribe((param: Params) => {
          this.schemeId = param['schemeId'];
          this.getBankDetails();
          console.log(this.schemeId);
        });
        this.activatedRoute.queryParams.subscribe((param: Params) => {
          this.projectType = param && param['projectType'] ? param['projectType'] : '';
        })
      });
    this.tpSchemeBankDetails = this.formBuilder.group({
      accountHolderName: ['', [Validators.required, Validators.maxLength(100)]],
      bankName: ['', [Validators.required, Validators.maxLength(50)]],
      accountNumber: ['', [Validators.required, Validators.pattern('[0-9]{9,18}')]],
      confirmAccountNumber: ['', [Validators.required, Validators.pattern('[0-9]{9,18}')]],

      ifscCode: ['', [Validators.required, Validators.pattern('^[A-Za-z]{4}[a-zA-Z0-9]{7}$')]],
      bankAddress: ['', [Validators.required, Validators.maxLength(200)]],
      accountType: [null, [Validators.required]],
      createdOn: [''],
    })
    this.verifyOTPForm = this.formBuilder.group(
      {
        'emailOTP': ['', [Validators.required]],
        'mobileOTP': ['', [Validators.required]]
      });
    this.tpSchemeBankDetails.get('bankName').disable();
    this.tpSchemeBankDetails.get('bankAddress').disable();

    console.log(this.tpSchemeBankDetails);

  }

  ngOnInit() {
    this.getcurrentUser();

  }

  getBankDetails() {
    this.bankDetailsData = [];
    this.utlityService.getBankDetails(this.schemeId).subscribe(res => {
      if (res) {
        for (let index = 0; index < res.data.length; index++) {
          this.bankDetailsData = res.data[index].bankDetails
        }
      } else {
        this.bankDetailsData = [];
      }

      console.log(this.bankDetailsData);


    })
  }

  updateBankDetails(data) {
    if (data) {
      Helpers.openModal('bank-details-modal')
      this.tpSchemeBankDetails.get('bankName').patchValue(data.bankName)
      this.tpSchemeBankDetails.get('bankAddress').patchValue(data.bankAddress)
      this.tpSchemeBankDetails.get('accountNumber').patchValue(data.accountNumber)
      this.tpSchemeBankDetails.get('accountHolderName').patchValue(data.accountHolderName)
      this.tpSchemeBankDetails.get('ifscCode').patchValue(data.ifscCode)
      this.tpSchemeBankDetails.get('accountType').patchValue(data.accountType)
      this.tpSchemeBankDetails.get('createdOn').patchValue(data.createdOn)
    }



  }


  getBankAddressByIfscCode() {
    console.log(this.tpSchemeBankDetails.controls)
    console.log(this.tpSchemeBankDetails.get('ifscCode').value)
    let ifscCode = this.tpSchemeBankDetails.get('ifscCode').value;
    this.utlityService.getBankAddressByIfsc(ifscCode).subscribe(bankAddress => {

      if (bankAddress.message === 'Invalid IFSC Code') {
        if (this.tpSchemeBankDetails.get('ifscCode').value !== '') {
          toastr.error('Invalid IFSC Code')
          this.tpSchemeBankDetails.get('bankName').patchValue('')
          this.tpSchemeBankDetails.get('bankAddress').patchValue('')
          return;
        }
      }

      if (bankAddress) {
        this.tpSchemeBankDetails.get('bankName').patchValue(bankAddress.BANK)
        this.tpSchemeBankDetails.get('bankAddress').patchValue(bankAddress.ADDRESS)
        this.tpSchemeBankDetails.get('bankAddress').disable()

        this.tpSchemeBankDetails.get('bankName').disable();

      }
    })
  }

  addUpdateBankDetails() {
    Helpers.openModal('bank-details-modal');
  }

  mapPayLoad() {

    const DATA = {
      bankDetails: {
        bankName: this.tpSchemeBankDetails.getRawValue().bankName,
        accountHolderName: this.tpSchemeBankDetails.value.accountHolderName,
        accountNumber: this.tpSchemeBankDetails.value.accountNumber,
        ifscCode: this.tpSchemeBankDetails.value.ifscCode,
        bankAddress: this.tpSchemeBankDetails.getRawValue().bankAddress,
        accountType: this.tpSchemeBankDetails.value.accountType,
        createdOn: this.tpSchemeBankDetails.value.createdOn,

      }
    }
    console.log(DATA);
    return DATA.bankDetails;
  }

  closeModal() {
    Helpers.closeModal('bank-details-modal');
  }



  submitBankDetails() {
    if (this.tpSchemeBankDetails.get('bankName').value === '') {
      toastr.error('Bank Name is required');
      return
    }
    if (this.tpSchemeBankDetails.get('bankAddress').value === '') {
      toastr.error('Bank Address is required');
      return
    }
    if (this.tpSchemeBankDetails.get('confirmAccountNumber').value !== this.tpSchemeBankDetails.get('accountNumber').value) {
      toastr.error('Account Number and confirm Account Number does not match');
      return;
    }

    this.mapPayLoad();
    // Helpers.openModal('otp-model');
    this.generateOtp();

    // this.utlityService.addUpdateBankDetails(this.mapPayLoad()).subscribe(res => {
    //   swal('Bank Details Successfully Added', '', 'success');
    //   this.getBankDetails();

    // })
    // this.closeModal();

  }

  addBankDetails() {
    this.tpSchemeBankDetails.reset();
    Helpers.openModal('bank-details-modal');
  }

  onBack() {
    this.location.back();
  }
  generateOtp() {
    let payload = {
      type: this.projectType == 'PM Vishwakarma' ? 'PMV' : 'SID',
      UserName: this.currentUserDetails?.userName || '',
      Email: this.currentUserDetails?.spoc?.email || '',
      phoneNumber: this.currentUserDetails?.spoc?.mobileNumber || ''
    }
    const email = this.currentUserDetails.email || '';
    const mobileNumber = this.currentUserDetails.phone.mobile || '';
    this.userService.generateOTPforUpdateBankDetails(payload, this.currentUserDetails.role,'updateTPBankDetail').subscribe(res => {
      console.log(res);
      if (res) {
        Helpers.openModal('otp-model');
      }
    })
  }


  verifyOTP() {
    if (this.verifyOTPForm.invalid) {
      toastr.error('Please fill the otp');
      return
    }
    var otpDetails = {
      emailOtp: this.verifyOTPForm.get('emailOTP').value ? this.verifyOTPForm.get('emailOTP').value : "0",
      phoneOtp: this.verifyOTPForm.get('mobileOTP').value ? this.verifyOTPForm.get('mobileOTP').value : "0",
      userID: this.currentUserDetails.userName,
    };
    // removed the previous method".verifyOTPForTPTCSpoc" as new otp api added
    this.registrationService.verifyBankDetailsOtps(otpDetails).subscribe(res => {
      if (res && res.msg == 'Valid OTP') {
        toastr.success('OTP verified successfully!!');
        this.closeOTPModel();
        this.utlityService.addUpdateBankDetails(this.mapPayLoad()).subscribe(res => {
          swal('Bank Details Successfully Added', '', 'success');
          this.getBankDetails();
        })
        this.closeModal();
      } else {
        toastr.warn(res && res.msg);
      }
    })
  }


  closeOTPModel() {
    this.verifyOTPForm.get('emailOTP').reset();
    this.verifyOTPForm.get('mobileOTP').reset();
    Helpers.closeModal('otp-model');
  }
  getcurrentUser() {
    // this.currentUserService.getAdditionalInfomartion().subscribe(
    this.currentUserService.getAdditionalInfomartion().subscribe(
      data => {
        // const userInfo = JSON.parse(localStorage.getItem('loginUserData'))
        this.currentUserDetails = data;
        console.log(this.currentUserDetails);
      }, err => {
        console.log(`Error in fetching current user detail ${err}`);
      }
    );
  }


}
